import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getFilesByLocation(template, location, platform, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/template/get-template/${template}/location/${location}/${platform}`,
			params: { country: Enviroment.COUNTRY, pharmacy: pharmacy },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
	async getAllTemplates(platform, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/template/get-template-by-pharmacy/${Enviroment.COUNTRY}/${pharmacy}/${platform}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
	async updateFilePosition(token, data) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.API_PHARMACY}/template/update-file-position`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: data,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
	async updateFileStatus(token, data) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.API_PHARMACY}/template/update-file-status`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: data,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async updateFile(token, data) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.API_PHARMACY}/template/update-file`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: data,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async deleteFile(token, data) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.API_PHARMACY}/template/delete-file`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: data,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
	async getPharmacies() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/pharmacies/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getModulesByTemplate(template, platform, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/template/get-modules-by-template/${template}/${platform}/${Enviroment.COUNTRY}/${pharmacy}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async createFile(token, data) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.API_PHARMACY}/template/create-file`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: data,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async updateModule(token, data) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.API_PHARMACY}/template/update-module`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: data,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
}
